import { FC } from 'react';
import { FormattedDate } from 'react-intl';
import cs from 'classnames';
import { UAH } from '@smart-kasa/ui';

import { TransactionPaymentType } from 'services/api/core/transactions/enums';
import type { IPaymentTransaction } from 'services/api/core/transactions/types';

import { PaymentType } from '../PaymentType';
import { TransactionPaymentMethod } from '../TransactionPaymentMethod';
import styles from './Transaction.module.scss';

interface IStatsTransactionsItem {
  transaction: IPaymentTransaction;
}

export const Transaction: FC<IStatsTransactionsItem> = ({ transaction }) => {
  const decrease = [TransactionPaymentType.refund, TransactionPaymentType.reversal].includes(
    transaction.paymentTypeId
  );
  const openReceipt = () =>
    window.open(`https://receipt.smartkasa.ua/${transaction.receiptId}`, '_blank', 'noreferrer');

  return (
    <div className={styles.item} onClick={openReceipt}>
      <div className={styles.status}>
        <PaymentType size="small" status={transaction.paymentTypeId} />
      </div>

      <div
        className={cs(styles.header, {
          [styles.highlighted]: transaction.paymentTypeId === TransactionPaymentType.reversal,
        })}
      >
        {transaction.rrn}
        <UAH colored value={Number(transaction.amount) * (decrease ? -1 : 1)} />
      </div>

      <div className={styles.footer}>
        <FormattedDate value={transaction.timestamp} dateStyle="short" timeStyle="short" />

        <div className={styles.type}>
          <TransactionPaymentMethod type={transaction.transactionTypeId} />
        </div>
      </div>
    </div>
  );
};
